import React, { Component } from "react";

import Icons from "../icons-helper";

import { ButtonWrapper } from "./styled";

type ButtonProps = {
  color?: string;
  backgroundColor?: string;
  disabled?: boolean;
  title: string;
  type?: "submit" | "button";
  icon?: string | Component;
  onClick?: () => void;
  border?: boolean;
};

const ButtonComponent: React.FC<ButtonProps> = ({
  title,
  color,
  backgroundColor,
  disabled,
  type,
  icon,
  onClick,
  border = false,
}) => (
  <ButtonWrapper
    type={type}
    backgroundColor={backgroundColor}
    color={color}
    disabled={disabled}
    border={border}
    onClick={onClick}
  >
    {typeof icon === "string" && (
      <Icons name={icon} width={20} height={20} color={color} />
    )}
    {title}
  </ButtonWrapper>
);

export default ButtonComponent;
